import {
  createFileRoute,
  type ErrorComponentProps,
} from "@tanstack/react-router";

// Direct module paths, not the @/customers barrel — validateSearch and the
// loader stay eager, so the barrel would drag CustomerDetailView -> DataTable
// into the entry chunk. Same hazard docs/agents/frontend-routing.md documents.
import { QueryState } from "@/components/QueryState";
import { CustomerDetailPage } from "@/customers/CustomerDetailPage";
import { validateCustomerDetailSearch } from "@/customers/detailSearch";
import { loadCustomerDetail } from "@/customers/loadCustomerDetail";
import { pageTitle } from "@/i18n/title";

function CustomerDetailPending() {
  return <QueryState error={null} />;
}

function CustomerDetailError({ error }: ErrorComponentProps) {
  const asError = error instanceof Error ? error : new Error(String(error));
  return <QueryState error={asError} />;
}

export const Route = createFileRoute("/_authed/customers/$customerId/")({
  validateSearch: validateCustomerDetailSearch,
  // ?tab= is search-only. It is not a loader dependency, and a revisit of the
  // same client does not block on the loader again.
  loaderDeps: () => ({}),
  staleTime: Number.POSITIVE_INFINITY,
  loader: ({ context, params, preload }) =>
    loadCustomerDetail(context.queryClient, params.customerId, preload),
  head: () => pageTitle("Client"),
  pendingComponent: CustomerDetailPending,
  errorComponent: CustomerDetailError,
  component: CustomerDetailPage,
});
